// extracted by mini-css-extract-plugin
export default {"container":"TransparencySlider_container__2br3a"};